import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const GET_UNIFIED_EVENT_USAGES = registerQuery({
  fieldName: 'unifiedEventUsages',
  args: ['eventType', 'eventTypeId'],
  fetcher({
    eventType,
    eventTypeId
  }) {
    return http.get(`crm-usages/v2/usages/${eventType}/${eventTypeId}/parents`);
  }
});